import { css } from 'styled-components';

const sizes = {
  giant: 1170,
  desktop: 992,
  tablet: 768,
  phone: 414
};

export const media = Object.keys(sizes).reduce((accumulator, label) => {
  const emSize = sizes[label] / 16;
  accumulator[label] = (templateStringsArray: TemplateStringsArray, ...args: (number | string)[]) => css`
    @media (max-width: ${emSize}em) {
      ${css(templateStringsArray, ...args)}
    }
  `;
  return accumulator;
},                                             {});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/style-utils.ts